<template>
	<article class="crema-signup-list">
		<PageHeader />
		<ManagingSection :isTable="true">
			<HorizontalSearch
				:blockElem="true"
				@search="searching"
				@init="initializing"
			>
				<SelectInput
					ref="searchType"
					:defaultSelectValue="searchTypeList[0].value"
					:selectList="searchTypeList"
					placeholder="입력하세요"
					@change="searchTypeChange"
				/>
				<SelectInput
					ref="period"
					label="요청일"
					:usePeriod="true"
					@change="periodChange"
				/>
			</HorizontalSearch>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<span class="section__info__left">
					검색결과 : {{ totalItem | currency }}
					<br />
					{{ countInfo }}
				</span>
				<div class="section__info__right">
					<div class="section__info__items">
						<Selector
							v-model="status"
							title="검수상태"
							:optionList="statusList"
							@input="statusInput"
						/>
					</div>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="crema-signup-list__table-item--id">No</th>
						<th class="crema-signup-list__table-item--date">
							요청일시
						</th>
						<th>브랜드명</th>
						<th>브랜드항번</th>
						<th>소속</th>
						<th class="crema-signup-list__table-item--admin">
							담당자명
						</th>
						<th>연락처</th>
						<th>이메일</th>
						<th class="crema-signup-list__table-item--date">
							답변일시
						</th>
						<th class="crema-signup-list__table-item--admin">
							관리자
						</th>
						<th class="crema-signup-list__table-item--status">
							검수
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.id">
						<td class="crema-signup-list__table-item--id">
							{{ item.id }}
						</td>
						<td class="crema-signup-list__table-item--date">
							{{ item.createdAtStr }}
						</td>
						<td>{{ item.brandName }}</td>
						<td>{{ item.brandId || '-' }}</td>
						<td>{{ item.department }}</td>
						<td class="crema-signup-list__table-item--admin">
							{{ item.name }}
						</td>
						<td>{{ item.tel }}</td>
						<td>{{ item.email }}</td>
						<td class="crema-signup-list__table-item--date">
							{{ item.updatedAtStr }}
						</td>
						<td class="crema-signup-list__table-item--admin">
							{{ item.adminAccountName }}
						</td>
						<td class="crema-signup-list__table-item--status">
							<div v-if="item.status === '진행중'">
								<button
									class="btn blue crema-signup-list__status-button"
									v-text="'승인'"
									@click="statusUpdate('승인', item.id)"
								/>
								<button
									class="btn red crema-signup-list__status-button"
									v-text="'반려'"
									@click="statusUpdate('반려', item.id)"
								/>
							</div>
							<p
								v-else
								:class="
									item.status === '승인'
										? 'font-blue'
										: 'font-red'
								"
								v-text="item.status"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="totalItem"
				:limit="limit"
				:offset="offset"
				@to="paging"
			/>
		</ManagingSection>
	</article>
</template>
<script>
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import util from '@/util.js';
	import isEqual from 'lodash/isEqual';
	import isEmpty from 'lodash/isEmpty';

	export default {
		name: 'CremaSignupList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			Selector,
			PaginationBox,
		},
		data() {
			const searchTypeList = [
				{ value: 'brand', name: '브랜드명' },
				{ value: 'name', name: '담당자명' },
				{ value: 'email', name: '메일주소' },
				{ value: 'tel', name: '연락처' },
			];
			const statusList = [
				{ value: null, name: '전체' },
				{ value: '진행중', name: '진행중' },
				{ value: '반려', name: '반려' },
				{ value: '승인', name: '승인' },
			];

			return {
				searchTypeList,
				searchType: searchTypeList[0].value,
				query: '',
				minDate: '',
				maxDate: '',
				list: [],
				totalItem: 0,
				countInfo: '',
				statusList,
				status: statusList[0].value,
				offset: 0,
				limit: 20,
			};
		},
		methods: {
			setQuery(params) {
				const query = {
					...params,
					offset: String(params.offset),
				};
				delete query.limit;
				if (isEqual(this.$route.query, query)) return;
				this.$router.replace({ query });
			},
			setFilter() {
				const query = this.$route.query;
				if (isEmpty(query)) return;
				if (query.query) {
					this.query = query.query;
					this.$refs.searchType.inputModel = query.query;
				}
				if (query.offset) {
					this.offset = Number(query.offset);
				}
				if (query.searchType) {
					this.searchType = query.searchType;
					this.$refs.searchType.selectModel = query.searchType;
				}
				if (query.status) {
					this.status = query.status;
				}
				if (query.minDate) {
					this.minDate = query.minDate;
				}
				if (query.maxDate) {
					this.maxDate = query.maxDate;
				}
				this.$refs.period.changePeriod({
					from: this.minDate,
					to: this.maxDate,
				});
			},
			async searching() {
				try {
					this.$store.commit('toggleSpinner', true);
					const query = this.query;
					const status = this.status;
					const minDate = this.minDate;
					const maxDate = this.maxDate;
					const params = {
						offset: this.offset,
						limit: this.limit,
					};
					if (query) {
						params.searchType = this.searchType;
						params.query = query;
					}
					if (status) {
						params.status = this.status;
					}
					if (minDate) {
						params.minDate = minDate;
					}
					if (maxDate) {
						params.maxDate = maxDate;
					}
					const { data } = await this.$axiosAdmin2NoSpinner.get(
						'/api/crema/partners',
						{ params }
					);
					const {
						totalCount,
						progressCount,
						rejectedCount,
						approvedCount,
					} = data.partnerAccountCount;
					this.list = data.partnerAccountList.data;
					this.totalItem = data.partnerAccountList.contentTotal;
					this.countInfo = `총 등록 (${util.currency(totalCount)}) | 진행 중 (${util.currency(progressCount)}) | 반려 (${util.currency(rejectedCount)}) | 승인 (${util.currency(approvedCount)})`;
					this.setQuery(params);
				} catch (err) {
					console.error(err);
					alert('리스트를 불러오는데 실패했습니다.');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			initializing() {
				this.searchType = this.searchTypeList[0].value;
				this.query = '';
				this.minDate = '';
				this.maxDate = '';
				this.$refs.searchType.init();
				this.$refs.period.init();
				this.status = this.statusList[0].value;
				this.offset = 0;
				this.searching();
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this.query = input;
			},
			periodChange({ from, to }) {
				this.minDate = from;
				this.maxDate = to;
			},
			statusInput() {
				this.offset = 0;
				this.searching();
			},
			paging({ offset }) {
				this.offset = offset;
				this.searching();
			},
			async statusUpdate(status, id) {
				try {
					if (!confirm(`${id}번 요청을 ${status} 처리하겠습니까?`))
						return;
					const url = `/api/crema/partner/${id}/status-update`;
					const params = { status };
					if (status === '승인') {
						this.$store.commit('modal/toggleModal', {
							id: 'CremaLinkAccount',
							params: {
								cb: async params2 => {
									try {
										await this.$axiosAdmin2.put(url, {
											...params,
											...params2,
										});
										alert('상태 업데이트 성공했습니다');
										this.searching();
										this.$store.commit(
											'modal/toggleModal',
											false
										);
									} catch (err) {
										console.error(err);
										alert('상태 업데이트 실패했습니다');
									}
								},
							},
						});
					} else {
						await this.$axiosAdmin2.put(url, params);
						alert('상태 업데이트 성공했습니다');
						this.searching();
					}
				} catch (err) {
					console.error(err);
					alert('상태 업데이트 실패했습니다');
				}
			},
		},
		mounted() {
			this.setFilter();
			this.searching();
		},
	};
</script>
<style lang="scss">
	.crema-signup-list {
		&__table-item--id {
			width: 60px;
			padding: 0;
		}

		&__table-item--date,
		&__table-item--product-id,
		&__table-item--review-cnt,
		&__table-item--admin {
			width: 90px;
			padding: 0;
		}

		&__table-item--status {
			width: 76px;
		}

		&__link {
			word-wrap: break-word;
		}

		&__status-button {
			display: block !important;
			margin: 0 auto;
		}
	}
</style>
